import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubteams = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M60.0001 21.6667V15L36.6667 15V36.6667H21.6667V43.3333H36.6667V65H60.0001V58.3333L43.3334 58.3333L43.3334 43.3333L60.0001 43.3333L60.0001 36.6667L43.3334 36.6667V21.6667L60.0001 21.6667Z",
			fill: "#90CAF9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 28.3334L26.6667 28.3334L26.6667 51.6667H10L10 28.3334Z",
			fill: "#D81B60"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.8333 11.5L68.4999 11.5V25.1667H54.8333V11.5ZM54.8333 54.8333H68.4999L68.4999 68.5H54.8333V54.8333ZM54.8333 33.1667H68.4999V46.8333H54.8333V33.1667Z",
			fill: "white",
			stroke: "#2196F3",
			strokeWidth: 3
		})
	]
});
export default SvgSubteams;
